

















import { Component, Prop, Vue } from 'vue-property-decorator'
import ky from 'ky'
import { Route } from 'vue-router'
import { ExStore } from 'vuex'
import store from '@/store'
import ScheduleForm, {
  ROUTING_TYPE_CREATE,
  ROUTING_TYPE_EDIT
} from '@/components/scheduleForm/ScheduleForm.vue'

@Component({
  components: {
    ScheduleForm: ScheduleForm
  }
})
export default class EditSchedule extends Vue {
  @Prop(Number) readonly patientId?: number
  @Prop(Number) readonly scheduleId?: number
  @Prop(String) readonly routingType!: string

  $store!: ExStore
  isContentPendding = true

  get preText() {
    return this.$store.getters['preInputs/text']
  }

  get currentPatientId() {
    if (this.routingType === ROUTING_TYPE_CREATE) {
      return this.patientId as number
    }

    const schedules = this.$store.getters['schedule/schedules']

    return schedules[this.scheduleId as number].patient
  }

  get patient() {
    return this.$store.getters['patient/patients'][this.currentPatientId]
  }

  get schedule() {
    if (this.routingType === ROUTING_TYPE_CREATE) {
      return undefined
    }
    return this.$store.getters['schedule/schedules'][this!.scheduleId as number]
  }

  get watchingWorkers() {
    return this.$store.getters['watchingWorker/workersAsArray']
  }

  loadCreateContents(patientId: number) {
    return Promise.all([
      this.$store.dispatch('patient/addOne', { patientId: patientId }),
      this.$store.dispatch('watchingWorker/add', { patientIds: [patientId] })
    ])
  }

  async loadEditContents(scheduleId: number) {
    await this.$store.dispatch('schedule/load', { scheduleId })

    const schedules = this.$store.getters['schedule/schedules']

    return Promise.all([
      this.$store.dispatch('watchingWorker/add', {
        patientIds: [schedules[this.scheduleId as number].patient]
      }),
      this.$store.dispatch('patient/addOne', {
        patientId: schedules[this.scheduleId as number].patient
      })
    ])
  }

  async created() {
    try {
      this.$store.dispatch('scheduleType/refresh')

      switch (this.routingType) {
        case ROUTING_TYPE_CREATE:
          await this.loadCreateContents(this.patientId as number)
          break

        case ROUTING_TYPE_EDIT:
          await this.loadEditContents(this.scheduleId as number)
          break

        default:
          throw new Error(
            `${this.$route.name} is not defined as a route's name`
          )
      }
    } catch (error) {
      if (error instanceof ky.HTTPError) {
        if (error.response.status === 404) {
          this.$router.push('/404')
          return
        }
      }
      // 例外処理
    }

    this.isContentPendding = false
  }

  beforeRouteEnter(to: Route, from: Route, next: () => void) {
    if (to.query.preInputToken) {
      if (to.query.preInputToken !== store.getters['preInputs/token']) {
        store.commit('preInputs/clear')
      }
    }
    next()
  }

  beforeRouteLeave(to: Route, from: Route, next: () => void) {
    store.commit('preInputs/clear')
    next()
  }
}
